import { Link } from "react-router-dom";

export default function Error404() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-48 h-48 bg-purple-500/10 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl"></div>

      <div className="text-center z-10 px-4">
        {/* Logo Section */}
        <div className="mb-16">
          <div className="flex items-center justify-center mb-2">
            <div className="text-left">
              <img width={300} src="/logos/ironpipeline.svg" />
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="bg-slate-800/30 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-12 max-w-md mx-auto">
          {/* 404 Number */}
          <h2 className="text-8xl font-bold text-white mb-6 tracking-tight">404</h2>

          {/* Error Message */}
          <h3 className="text-lg sm:text-xl font-semibold text-white mb-4">Here Is Some Problem</h3>
          <p className="text-gray-400 mb-8 text-sm leading-relaxed">The page you are looking for it maybe deleted</p>

          {/* Go Home Button */}
          <Link
            to="/"
            className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-medium px-8 py-3 rounded-lg transition-colors duration-200 text-sm"
          >
            Go To Home
          </Link>
        </div>
      </div>
    </div>
  );
}
